/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import axiosInstance from './axios';

export const depositBalance = async (
  phone: string,
  amount: number,
  venueId: string,
  isCash: boolean,
  isPosnet: boolean,
  localTimeZone: string,
): Promise<boolean> => {
  try {
    const { data } = await axiosInstance({
      method: 'POST',
      url: 'users/deposit-balance',
      data: {
        phone,
        amount,
        venueId,
        isCash,
        isPosnet,
        localTimeZone,
      },
    });
    return data !== null;
  } catch (error: any) {
    console.log(error);
    return false;
  }
};
